"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JsonToTable_1 = require("./JsonToTable");
exports.default = JsonToTable_1.default;
//# sourceMappingURL=index.js.map